export default __webpack_public_path__ + "static/media/trash.82d3b329.svg";